module.exports = __webpack_public_path__ + "img/d854f4a.png";